module.exports = __webpack_public_path__ + "static/media/logo-text.928703eb.png";